"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconBasementFilled = function IconBasementFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.36 17.36L38.36 14.72V8.24C38.36 7.94296 38.242 7.65808 38.0319 7.44804C37.8219 7.238 37.537 7.12 37.24 7.12H31.67C31.3729 7.12 31.0881 7.238 30.878 7.44804C30.668 7.65808 30.55 7.94296 30.55 8.24V9.49L25.6 6.2C25.405 6.06845 25.1752 5.99816 24.94 5.99816C24.7048 5.99816 24.4749 6.06845 24.28 6.2L7.52998 17.36C7.36556 17.4696 7.23102 17.6184 7.13849 17.793C7.04596 17.9675 6.99836 18.1624 6.99998 18.36V42.8C6.99998 42.9576 7.03102 43.1136 7.09132 43.2592C7.15163 43.4048 7.24002 43.5371 7.35145 43.6485C7.46288 43.76 7.59517 43.8484 7.74076 43.9087C7.88635 43.969 8.04239 44 8.19998 44H41.68C41.8376 44 41.9936 43.969 42.1392 43.9087C42.2848 43.8484 42.4171 43.76 42.5285 43.6485C42.6399 43.5371 42.7283 43.4048 42.7886 43.2592C42.8489 43.1136 42.88 42.9576 42.88 42.8V18.35C42.8802 18.1552 42.8329 17.9632 42.7423 17.7907C42.6517 17.6182 42.5205 17.4704 42.36 17.36ZM32.47 13.28C32.397 13.3229 32.3145 13.3469 32.23 13.35C32.3151 13.3504 32.3984 13.326 32.47 13.28ZM39.64 40.76H36V37.5C36 37.3674 35.9473 37.2402 35.8535 37.1464C35.7598 37.0527 35.6326 37 35.5 37H33V33.5C33 33.3674 32.9473 33.2402 32.8535 33.1464C32.7598 33.0527 32.6326 33 32.5 33H10.24V19.52L24.94 9.83L29 12.56L31.33 14.09C31.5657 14.2458 31.8393 14.3346 32.1216 14.347C32.4038 14.3594 32.6842 14.2949 32.9326 14.1604C33.1811 14.0259 33.3884 13.8264 33.5323 13.5833C33.6763 13.3402 33.7515 13.0625 33.75 12.78V10.35H35.11V15.79C35.1078 16.0506 35.1718 16.3075 35.296 16.5366C35.4202 16.7657 35.6005 16.9596 35.82 17.1L39.6 19.53L39.64 40.76Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.64 23.27C29.4132 23.0434 29.1056 22.9162 28.785 22.9162C28.4644 22.9162 28.1569 23.0434 27.93 23.27L26.21 25V18.19C26.21 17.8691 26.0825 17.5613 25.8556 17.3344C25.6287 17.1075 25.3209 16.98 25 16.98C24.6791 16.98 24.3713 17.1075 24.1444 17.3344C23.9175 17.5613 23.79 17.8691 23.79 18.19V25L22.07 23.31C21.8432 23.0834 21.5356 22.9562 21.215 22.9562C20.8944 22.9562 20.5869 23.0834 20.36 23.31C20.246 23.4192 20.1552 23.5504 20.0932 23.6956C20.0312 23.8408 19.9993 23.9971 19.9993 24.155C19.9993 24.3129 20.0312 24.4692 20.0932 24.6144C20.1552 24.7596 20.246 24.8908 20.36 25L24.14 28.73C24.3699 28.9548 24.6786 29.0806 25 29.0806C25.3215 29.0806 25.6302 28.9548 25.86 28.73L29.64 25C29.7604 24.8903 29.8566 24.7568 29.9224 24.6078C29.9882 24.4589 30.0222 24.2978 30.0222 24.135C30.0222 23.9722 29.9882 23.8111 29.9224 23.6622C29.8566 23.5132 29.7604 23.3796 29.64 23.27Z",
    fill: color
  }));
};

IconBasementFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconBasementFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconBasementFilled;
exports.default = _default;